/* Ceremony — site interactions (cleaned for live: real Shopify cart, no demo) */
(function(){
  document.documentElement.classList.add('js');

  /* reveal on scroll */
  var reveals=document.querySelectorAll('.reveal');
  if(reveals.length){
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    reveals.forEach(function(el){io.observe(el);});
    var revealInView=function(){document.querySelectorAll('.reveal:not(.in)').forEach(function(el){if(el.getBoundingClientRect().top<window.innerHeight*0.92)el.classList.add('in');});};
    requestAnimationFrame(function(){requestAnimationFrame(revealInView);});
    setTimeout(revealInView,200);
    setTimeout(function(){document.querySelectorAll('.reveal:not(.in)').forEach(function(el){el.classList.add('in');});},2600);
  }

  /* mobile menu */
  var mt=document.querySelector('.menu-toggle'), mob=document.querySelector('.mobile-menu');
  if(mt&&mob){
    mt.addEventListener('click',function(){mob.classList.toggle('open');document.body.classList.toggle('menu-open');});
    mob.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mob.classList.remove('open');document.body.classList.remove('menu-open');});});
  }

  /* hero media toggle (if present) */
  var heroBtns=document.querySelectorAll('.hero-switch button');
  if(heroBtns.length){
    var heroModes=document.querySelectorAll('.hero-media [data-mode]');
    heroBtns.forEach(function(b){b.addEventListener('click',function(){heroBtns.forEach(function(x){x.classList.toggle('on',x===b);});var m=b.dataset.hero;heroModes.forEach(function(el){el.hidden=el.dataset.mode!==m;});});});
  }
})();
